// Importing action types and initial state
import * as types from "../Actions/ActionTypes"; // Action types for Redux actions
import initialState from "./initailState"; // Initial state for the reducer

// Reducer function to manage user roles
const userRole = (state = initialState.roles, action) => {
  switch (action.type) {
    // Handle setting user roles
    case types.SET_USER_ROLE:
      return { ...state, userList: action.data };

    // Handle resetting the reducer state
    case types.REST_REDUCER_STATE:
      return { ...state, userList: action.data };

    // Default case to return the current state
    default:
      return state;
  }
};

// Exporting the reducer as the default export
export default userRole;
